import { createFileRoute } from '@tanstack/react-router'

import EditGapoktanPage from '@/components/pages/backoffice/_klb-petani/_gapoktan/_$gapoktanId/_edit/containers/EditGapoktanPage'

export const Route = createFileRoute(
  '/_backoffice/klb-petani/gapoktan/$gapoktanId/edit'
)({
  component: EditGapoktanPage
})
